import React from 'react';
import { Settings as SettingsIcon, Database, Info } from 'lucide-react';

export default function Settings() {
  return (
    <div className="fade-in" style={{ maxWidth: 600 }}>
      <h1 style={{ marginBottom: 24 }}>Settings</h1>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-header"><h3>About ForgeIQ</h3></div>
        <div style={{ fontSize: 12, color: 'var(--forge-text2)', lineHeight: 1.8 }}>
          <p><strong style={{ color: 'var(--forge-text)' }}>Version:</strong> Phase 1 Build · March 2026</p>
          <p><strong style={{ color: 'var(--forge-text)' }}>Engineering Rules:</strong> v2.1 — derived from 60+ production drawings</p>
          <p><strong style={{ color: 'var(--forge-text)' }}>Machines:</strong> 6 fully characterised (11B6S, 14B6S, 19B6S, 24B6S, SJBF-134L, SJBF-164S)</p>
          <p><strong style={{ color: 'var(--forge-text)' }}>Templates:</strong> A, A-EXT, B, B-S, C, D1, D2, D3, D4, D5, D6</p>
          <p><strong style={{ color: 'var(--forge-text)' }}>Client:</strong> Singhania International Limited / Sturdfix, Ludhiana</p>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-header"><h3>Data</h3></div>
        <p style={{ fontSize: 12, color: 'var(--forge-text2)', marginBottom: 12 }}>All job data is stored locally in your browser (localStorage). No data is sent to any server except when using AI parse.</p>
        <button className="btn btn-danger btn-sm" onClick={() => {
          if (window.confirm('Clear all local data? This cannot be undone.')) {
            localStorage.clear(); window.location.reload();
          }
        }}>
          <Database size={12} /> Clear all data
        </button>
      </div>

      <div className="card">
        <div className="card-header"><h3>Next Phases</h3></div>
        {[
          { phase: 'Phase 2', title: 'Process Planner', desc: 'Full parametric sequence engine, cross-section visualiser, station-level editing', status: 'planned' },
          { phase: 'Phase 3', title: 'Tool Drawing Generator', desc: 'Parametric DXF/PDF output, AutoCAD-compatible, all components per station', status: 'planned' },
          { phase: 'Phase 4', title: 'FEA Simulation', desc: 'GMSH + OpenRadioss/CalculiX, material flow, strain, forming load visualisation', status: 'planned' },
          { phase: 'Phase 5', title: '3D Model + Process Docs', desc: 'CadQuery 3D generator, STEP/STL export, process flow chart PDF', status: 'planned' },
        ].map(p => (
          <div key={p.phase} style={{ padding: '10px 0', borderBottom: '1px solid var(--forge-border)', display: 'flex', gap: 12 }}>
            <span className="badge badge-gray" style={{ flexShrink: 0, height: 'fit-content', marginTop: 2 }}>{p.phase}</span>
            <div>
              <div style={{ fontSize: 12, fontWeight: 600 }}>{p.title}</div>
              <div style={{ fontSize: 11, color: 'var(--forge-text3)', marginTop: 2 }}>{p.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
